import DigitalMapWeb from './components/digitalMap/web.vue';
import DigitalMapIos from './components/digitalMap/ios.vue';
import DigitalMapAndroid from './components/digitalMap/android.vue';
import SignalMapAndroid from './components/signalMap/android.vue';
import InnerTutorial from './components/inner/tutorial.vue';
import VisualMapWeb from './components/visualMap/web.vue';
import DigitalMapRN from './components/digitalMap/rn.vue';
import {
    calcSubPath
} from './util/sub_path';
const rootPath = process.env.NODE_ENV === 'production' ? calcSubPath() : '/';

const routes = [{
        path: rootPath,
        redirect: `${rootPath}digitalMapWeb`
    },
    {
        path: '*',
        redirect: `${rootPath}digitalMapWeb`
    },
    {
        path: `${rootPath}digitalMapWeb`,
        component: DigitalMapWeb
    },
    {
        path: `${rootPath}digitalMapIos`,
        component: DigitalMapIos
    },
    {
        path: `${rootPath}digitalMapAndroid`,
        component: DigitalMapAndroid
    },
    {
        path: `${rootPath}signalMapAndroid`,
        component: SignalMapAndroid
    },
    {
        path: `${rootPath}innerTutorial`,
        component: InnerTutorial
    },
    {
        path: `${rootPath}visualMapWeb`,
        component: VisualMapWeb
    },
    {
        path: `${rootPath}digitalMapRN`,
        component: DigitalMapRN
    }
];

export default routes;
